import { useContext } from 'react'
import { UserContext, type UserContextType } from '../../contexts/userContext'

/**
 * Хук для использования контекста пользователя
 * @returns Контекст пользователя с данными и функциями управления
 * @throws Ошибка, если хук используется вне UserProvider
 */
export function useUser(): UserContextType {
  const context = useContext(UserContext)

  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider')
  }

  return context
}
